// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D4ki","col":"styles_col__2ugWX"};